import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "GitLab CI",
  "description": "Turborepo와 함께 GitLab CI를 사용하는 방법을 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "다음 예제는 Turborepo를 GitLab CI와 함께 사용하는 방법을 보여줍니다."
  }, {
    "heading": "",
    "content": "주어진 루트 package.json의 경우:"
  }, {
    "heading": "",
    "content": "And a turbo.json:"
  }, {
    "heading": "",
    "content": "저장소에 다음 내용으로 .gitlab-ci.yml 파일을 생성합니다:"
  }, {
    "heading": "",
    "content": "자세한 내용은 GitLab CI 통합에 대한 pnpm 문서 섹션을 여기에서 확인하세요."
  }, {
    "heading": "remote-caching",
    "content": "Remote Caching을 사용하려면 제공자의 Remote Cache에 대한 팀과 토큰을 검색합니다. 이 예제에서는 Vercel Remote Cache를 사용합니다:"
  }, {
    "heading": "remote-caching",
    "content": "TURBO_TOKEN - Remote Cache에 액세스하기 위한 Bearer 토큰"
  }, {
    "heading": "remote-caching",
    "content": "TURBO_TEAM - 아티팩트를 공유할 Vercel 팀의 슬러그"
  }, {
    "heading": "remote-caching",
    "content": "Vercel Remote Caching을 사용하려면 몇 가지 단계로 이러한 변수의 값을 얻을 수 있습니다:"
  }, {
    "heading": "remote-caching",
    "content": "Vercel Dashboard에서 계정에 대한 Scoped Access Token을 생성합니다."
  }, {
    "heading": "remote-caching",
    "content": "값을 안전한 곳에 복사하세요. 잠시 후에 필요합니다."
  }, {
    "heading": "remote-caching",
    "content": "GitLab 저장소 설정으로 이동하여 Settings를 클릭한 다음 CI/CD 탭을 클릭합니다. TURBO_TOKEN이라는 새 변수를 생성하고 Scoped Access Token의 값을 입력합니다."
  }, {
    "heading": "remote-caching",
    "content": "TURBO_TEAM이라는 두 번째 비밀을 만들고 팀 URL에서 vercel.com/ 뒤의 부분인 팀 슬러그로 설정합니다. 예를 들어, vercel.com/acme의 슬러그는 acme입니다."
  }, {
    "heading": "remote-caching",
    "content": "이제 GitLab 워크플로에서 Remote Caching이 작동합니다."
  }],
  "headings": [{
    "id": "remote-caching",
    "content": "Remote Caching"
  }]
};
import __img0 from "./../../../../public/images/docs/vercel-create-token.png";
import __img1 from "./../../../../public/images/docs/gitlab-ci-variables.png";
import __img2 from "./../../../../public/images/docs/gitlab-ci-create-variable.png";
import {PackageManagerTabs, Tab} from '#components/tabs';
export const toc = [{
  depth: 2,
  url: "#remote-caching",
  title: _jsx(_Fragment, {
    children: "Remote Caching"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    code: "code",
    h2: "h2",
    img: "img",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["다음 예제는 Turborepo를 ", _jsx(_components.a, {
        href: "https://docs.gitlab.com/ee/ci/",
        children: "GitLab CI"
      }), "와 함께 사용하는 방법을 보여줍니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["주어진 루트 ", _jsx(_components.code, {
        children: "package.json"
      }), "의 경우:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"name\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"my-turborepo\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run test\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"devDependencies\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"turbo\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"latest\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["And a ", _jsx(_components.code, {
        children: "turbo.json"
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"https://turborepo.com/schema.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".svelte-kit/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["저장소에 다음 내용으로 ", _jsx(_components.code, {
        children: ".gitlab-ci.yml"
      }), " 파일을 생성합니다:"]
    }), "\n", _jsxs(PackageManagerTabs, {
      children: [_jsxs(Tab, {
        value: "pnpm",
        children: [_jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: ".gitlab-ci.yml",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "image"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " node:latest"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "stages"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "build"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "build"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  stage"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " build"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  before_script"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "curl -f https://get.pnpm.io/v6.16.js | node - add --global pnpm@6.32.2"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "pnpm config set store-dir .pnpm-store"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  script"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "pnpm install"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "pnpm build"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "pnpm test"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  cache"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    key"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      files"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "        - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "pnpm-lock.yaml"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    paths"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: ".pnpm-store"
                })]
              })]
            })
          })
        }), _jsxs(_components.blockquote, {
          children: ["\n", _jsxs(_components.p, {
            children: ["자세한 내용은 GitLab CI 통합에 대한 pnpm 문서 섹션을 ", _jsx(_components.a, {
              href: "https://pnpm.io/continuous-integration#gitlab",
              children: "여기"
            }), "에서 확인하세요."]
          }), "\n"]
        })]
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: ".gitlab-ci.yml",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "image"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " node:latest"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "stages"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "build"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "build"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  stage"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " build"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  script"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "yarn install"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "yarn build"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "yarn test"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  cache"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    paths"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "node_modules/"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: ".yarn"
                })]
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: ".gitlab-ci.yml",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "image"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " node:latest"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "stages"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "build"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "build"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  stage"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " build"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  script"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "npm install"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "npm run build"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "npm run test"
                })]
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun (Beta)",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: ".gitlab-ci.yml",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "default"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  image"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " oven/bun:1.2"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  cache"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    key"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      files"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "        - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "bun.lock"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    paths"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "node_modules/"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  before_script"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "bun install"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "build"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "script"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "bun run build"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "test"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "script"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "bun run test"
                })]
              })]
            })
          })
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "remote-caching",
      children: "Remote Caching"
    }), "\n", _jsxs(_components.p, {
      children: ["Remote Caching을 사용하려면 제공자의 Remote Cache에 대한 팀과 토큰을 검색합니다. 이 예제에서는 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/remote-caching",
        children: "Vercel Remote Cache"
      }), "를 사용합니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "TURBO_TOKEN"
        }), " - Remote Cache에 액세스하기 위한 Bearer 토큰"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "TURBO_TEAM"
        }), " - 아티팩트를 공유할 Vercel 팀의 슬러그"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Vercel Remote Caching을 사용하려면 몇 가지 단계로 이러한 변수의 값을 얻을 수 있습니다:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://vercel.com/account/tokens",
          children: "Vercel Dashboard"
        }), "에서 계정에 대한 Scoped Access Token을 생성합니다."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "Vercel Access Tokens",
        placeholder: "blur",
        src: __img0
      })
    }), "\n", _jsx(_components.p, {
      children: "값을 안전한 곳에 복사하세요. 잠시 후에 필요합니다."
    }), "\n", _jsxs(_components.ol, {
      start: "2",
      children: ["\n", _jsxs(_components.li, {
        children: ["GitLab 저장소 설정으로 이동하여 ", _jsx(_components.strong, {
          children: "Settings"
        }), "를 클릭한 다음 ", _jsx(_components.strong, {
          children: "CI/CD"
        }), " 탭을 클릭합니다. ", _jsx(_components.code, {
          children: "TURBO_TOKEN"
        }), "이라는 새 변수를 생성하고 Scoped Access Token의 값을 입력합니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.img, {
        alt: "GitLab CI Variables",
        placeholder: "blur",
        src: __img1
      }), "\n", _jsx(_components.img, {
        alt: "GitLab CI Create Variable",
        placeholder: "blur",
        src: __img2
      })]
    }), "\n", _jsxs(_components.ol, {
      start: "3",
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "TURBO_TEAM"
        }), "이라는 두 번째 비밀을 만들고 ", _jsx(_components.a, {
          href: "https://vercel.com/d?to=%2F%5Bteam%5D%2F%7E%2Fsettings&title=Find+Team+URL",
          children: "팀 URL"
        }), "에서 ", _jsx(_components.code, {
          children: "vercel.com/"
        }), " 뒤의 부분인 팀 슬러그로 설정합니다. 예를 들어, ", _jsx(_components.code, {
          children: "vercel.com/acme"
        }), "의 슬러그는 ", _jsx(_components.code, {
          children: "acme"
        }), "입니다."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "이제 GitLab 워크플로에서 Remote Caching이 작동합니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
